module.exports = __webpack_public_path__ + "img/player-bg.9cc0e2a7.png";